import { render } from "./UnidadeLayout.vue?vue&type=template&id=4b2c3fdc&scoped=true"
import script from "./UnidadeLayout.vue?vue&type=script&lang=js"
export * from "./UnidadeLayout.vue?vue&type=script&lang=js"

import "./UnidadeLayout.vue?vue&type=style&index=0&id=4b2c3fdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2c3fdc"]])

export default __exports__